import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "d-flex flex-column ga-2" }
const _hoisted_2 = { class: "d-flex align-center flex-wrap ga-2" }
const _hoisted_3 = { class: "d-flex align-center flex-wrap ga-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChipSelect = _resolveComponent("ChipSelect")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_Button = _resolveComponent("Button")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_timeline_item = _resolveComponent("v-timeline-item")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_timeline = _resolveComponent("v-timeline")!

  return (_openBlock(), _createBlock(_component_v_timeline, {
    side: "end",
    density: "compact",
    align: "start",
    "truncate-line": "both",
    class: "ms-flow"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.helpers, (h, i) => {
        return (_openBlock(), _createBlock(_component_v_timeline_item, {
          key: 'h' + i,
          "dot-color": "surface-variant",
          size: "x-small"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _cache[2] || (_cache[2] = _createElementVNode("span", { class: "text-body-1 text-medium-emphasis" }, "Ask", -1)),
                _createVNode(_component_ChipSelect, {
                  "model-value": h.agent,
                  options: _ctx.agentOptions(h.agent),
                  icon: "mdi-robot-outline",
                  "onUpdate:modelValue": (v) => _ctx.patchHelper(i, { agent: v })
                }, null, 8, ["model-value", "options", "onUpdate:modelValue"]),
                _cache[3] || (_cache[3] = _createElementVNode("span", { class: "text-body-1 text-medium-emphasis" }, "to read", -1)),
                _createVNode(_component_ChipSelect, {
                  "model-value": h.input,
                  options: _ctx.inputOptions,
                  icon: "mdi-database-outline",
                  "onUpdate:modelValue": (v) => _ctx.patchHelper(i, { input: v })
                }, null, 8, ["model-value", "options", "onUpdate:modelValue"]),
                _createVNode(_component_v_spacer),
                _createVNode(_component_Button, {
                  icon: "mdi-trash-can-outline",
                  tooltip: "Remove helper",
                  size: "small",
                  click: () => _ctx.removeHelper(i)
                }, null, 8, ["click"])
              ]),
              _createVNode(_component_v_text_field, {
                "model-value": h.role,
                variant: "plain",
                density: "compact",
                "hide-details": "",
                class: "ms-flow__role font-italic",
                "onUpdate:modelValue": (v) => _ctx.patchHelper(i, { role: v })
              }, null, 8, ["model-value", "onUpdate:modelValue"])
            ])
          ]),
          _: 2
        }, 1024))
      }), 128)),
      _createVNode(_component_v_timeline_item, {
        "dot-color": "surface",
        size: "x-small"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, {
            variant: "text",
            size: "small",
            color: "primary",
            "prepend-icon": "mdi-plus",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('add-helper')))
          }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createTextVNode(" Add a helper ")
            ])),
            _: 1,
            __: [4]
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_timeline_item, {
        "dot-color": "primary",
        size: "small",
        icon: "mdi-star-four-points"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_ChipSelect, {
              "model-value": _ctx.lead,
              options: _ctx.agentOptions(_ctx.lead),
              icon: "mdi-robot",
              accent: "",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = (v) => _ctx.$emit('update:lead', v))
            }, null, 8, ["model-value", "options"]),
            _cache[5] || (_cache[5] = _createElementVNode("span", { class: "text-body-1 text-medium-emphasis" }, "combines their work into the final result.", -1))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}